import React, { useState } from "react";

export default function FeedbackForm() {
  const [form, setForm] = useState({ name: "", email: "", mobile: "" });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await fetch("submit_feedback.php", {
      method: "POST",
      body: new URLSearchParams(form),
    });
    const result = await response.text();
    alert(result);
  };

  return (
    <form onSubmit={handleSubmit} className="grid gap-4">
      <input
        name="name"
        type="text"
        placeholder="Your Full name"
        maxLength="30"
        required
        className="border p-2 rounded"
        value={form.name}
        onChange={handleChange}
      />
      <input
        name="email"
        type="email"
        placeholder="you@example.com"
        maxLength="30"
        required
        className="border p-2 rounded"
        value={form.email}
        onChange={handleChange}
      />
      <input
        name="mobile"
        type="tel"
        placeholder="Mobile number"
        minLength="10"
        maxLength="15"
        required
        className="border p-2 rounded"
        value={form.mobile}
        onChange={handleChange}
      />
      <button
        type="submit"
        className="bg-[#0c1a2b] text-white px-4 py-2 rounded"
      >
        Submit
      </button>
    </form>
  );
}
